import React from 'react';
import { Box, Grid, Typography } from '@mui/material';

import countries, { Alpha3Code } from 'i18n-iso-countries';

import { Rule } from '../../../utilities/schemas/rules';
import languages from '../../../constants/languages';

export interface SustainedForeignIpCountryParams {
  lookbackPeriod: { amount: number; unit: string };
  expectedCountries: Alpha3Code[];
}

const SustainedForeignIpCountry = ({ rule }: {
  rule: Rule;
}) => {
  const { lookbackPeriod, expectedCountries } = rule
    .ruleParameters as SustainedForeignIpCountryParams;

  return (
    <>
      <Grid
        alignItems="baseline"
        size={{
          xs: 12,
          sm: 6,
          lg: 4,
        }}
      >
        <Box display="flex" flexDirection="row" gap={1} alignItems="baseline">
          <Typography sx={{ fontWeight: 'bold', fontSize: 10 }}>
            Lookback period
          </Typography>
          <Typography fontSize={10}>
            {`${lookbackPeriod.amount} ${lookbackPeriod.unit}`}
          </Typography>
        </Box>
      </Grid>
      <Grid
        alignItems="baseline"
        size={{
          xs: 12,
          sm: 6,
          lg: 4,
        }}
      >
        <Box display="flex" flexDirection="row" gap={1} alignItems="baseline">
          <Typography sx={{ fontWeight: 'bold', fontSize: 10 }}>
            Expected countries
          </Typography>
          <Typography fontSize={10}>
            {expectedCountries.map((country) => countries.getName(country, languages.EN)).join(', ')}
          </Typography>
        </Box>
      </Grid>
    </>
  );
};

export default SustainedForeignIpCountry;
